import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { useBlogSeo } from "@/hooks/use-blog-seo";
import { BlogIndexContent } from "@/components/blog-content";
import { saunaGuideIndex, SAUNA_QUOTE } from "@/data/sauna-seo";
import { BLOG_PATH } from "@/data/blog";
import "@/components/home/home.css";

export const BLOG_INDEX_SEO = {
  title: "Sauna Blog & Guides | Vertex Climate",
  description: "Practical sauna articles from Vertex Climate on design, equipment, installation, ventilation, electrical planning and long-term care.",
  path: BLOG_PATH,
  image: "sauna-detail-1.webp",
};

export default function Blog() {
  useBlogSeo(BLOG_INDEX_SEO);
  return (
    <div className="vx-home flex flex-col min-h-[100dvh] bg-background overflow-x-clip">
      <Header />
      <main className="flex-1">
        <BlogIndexContent base={import.meta.env.BASE_URL} guideHubHref={saunaGuideIndex.path} quoteHref={SAUNA_QUOTE} />
      </main>
      <Footer />
    </div>
  );
}
